export { default } from "./modal";
export type { ModalProps, ModalSize } from "./modal";
